// extracted by mini-css-extract-plugin
export default {"cartItem":"cartItem_cartItem__w7qJ+","left":"cartItem_left__aFJA1","remove":"cartItem_remove__4Jvu8","right":"cartItem_right__k2f56"};